export default function exhaustiveCheck<T>(
  x: never,
  errorMessage = `${x} is unhandled`,
): T {
  throw new Error(errorMessage);
}
